'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getComponentFromElement;
/**
 * Return instance from element
 * @param element: DOM element or ID of element
 * @returns component instance
 */

function getComponentFromElement(element) {
    if (typeof element === 'string') {
        element = document.getElementById(element);

        if (!element) {
            return null;
        }
    }

    return element['__gia_component__'];
}



//////////////////
// WEBPACK FOOTER
// /Users/yinminpan/Local Dev/business-events-tas/wp-content/themes/b-e-tas/node_modules/gia/getComponentFromElement.js
// module id = 18
// module chunks = 0